export default function PrintViewGuide() {
  return (
    <div
      className={`absolute right-4 top-24 flex w-64 cursor-text items-center rounded bg-white px-4 py-3 text-base print:hidden`}
    >
      You are currently in "Print View". Configure visible layers as needed. Works best with Landscape print layout.
    </div>
  );
}
